export const SET_DEAL_LIST = 'SET_DEAL_LIST';
